<template>
    <div class="search-statistics">
        <div class="form-wrapper" v-if="viewInitialized">
            <h2 class="page-title">Filter implementation statistics</h2>
            <form id="form"
                  class="form"
                  method="GET"
                  action="/"
                  @submit.prevent="changeCriteriaAndSearch(api)">
                <div class="form__wrapper">
                    <div class="form__field" v-for="field in schema" :key="field.Key">
                        <div class="form__label">{{ field.Name }}</div>
                        <component :is="field.Type"
                                   v-model="formData[field.Key]"
                                   :field="field"
                                   :disabled="field.Disabled"></component>
                    </div>
                </div>
                <button type="submit" class="form__submit-btn">Search</button>
            </form>
        </div>
        <div v-if="showLoader">
            <h6 class="loader">Loading ...</h6>
        </div>
        <div v-if="!showLoader && statistics.Rows">
            <table class="statistics-table">
                <thead class="statistics-table-head">
                    <tr class="statistics-table-row">
                        <td class="statistics-table-row-data">Group</td>
                        <td class="statistics-table-row-data">Property</td>
                        <td v-for="country in statistics.Countries" class="stat-td-center">{{country}}</td>
                        <td v-for="status in statistics.Statuses" class="stat-td-center">{{status}}</td>
                        <td>
                            <b>Total</b>
                        </td>
                    </tr>
                </thead>
                <tbody class="statistics-table-body">
                    <tr v-for="(row,index) in statistics.Rows"
                        :class="[(index <2)?'general-statistics statistics-table-row' : 'statistics-table-row', (row.Property === 'TOTAL')?'summary-row' : '']">
                        <td class>{{row.GroupName}}</td>
                        <td class>{{row.Property}}</td>
                        <td v-for="country in statistics.Countries"
                            class="stat-td-center">
                            {{row.CountryValues[country]}}
                        </td>
                        <td v-for="status in statistics.Statuses"
                            class="stat-td-center">
                            {{row.StatusOfImplementationValues[status]}}
                        </td>
                        <td>
                            <b>{{row.Total}}</b>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import MultiSelectWrapper from "./custom-inputs/MultiSelectWrapper";
    import NumberInput from "./custom-inputs/NumberInput";
    import TextboxInput from "./custom-inputs/TextboxInput";
    import CheckboxInput from "./custom-inputs/CheckboxInput";
    import DateInput from "./custom-inputs/DateInput";
    import SearchResults from "./SearchResults";
    import SortDropdown from "./partials/SortDropdown";
    import CriteriaList from "./partials/CriteriaList";
    import ExportLoader from "./partials/ExportLoader";
    import axios from "axios";
    import queryString from "query-string";
    import isEmpty from "lodash/isEmpty";
    import moment from "moment";
    import FilesExportApi from "../api/filesExportApi.js";
    import ContentApi from "../api/contentApi.js";
    import ProjectBeneficiariesService from "../services/projectBeneficiariesService.js";

    const allAdvancedStatisticsAPI = "umbraco/surface/api/getAllAdvancedStatistics";
    const advancedStatisticsAPI = "/umbraco/surface/api/getAdvancedStatistics";
    export default {
        name: "AdvancedStatisticsForm",
        components: {
            MultiSelectWrapper,
            NumberInput,
            TextboxInput,
            CheckboxInput,
            SearchResults,
            SortDropdown,
            CriteriaList,
            DateInput
        },
        data() {
            return {
                schema: [],
                results: [],
                formData: {},
                criterias: {},
                query: queryString.parse(location.search),
                showCriterias: false,
                showForm: true,
                searchActive: false,
                searchFinished: false,
                loaderText: "Loading...",
                showLoader: false,
                viewInitialized: false,
                statistics: []
            };
        },
        methods: {
            changeCriteriaAndSearch(api) {
                this.$delete(this.criterias, "page");
                this.$delete(this.criterias, "query");
                this.sendForm();
            },
            sendForm() {
                this.showLoader = true;

                history.pushState(null, null, "?" + queryString.stringify(this.formData));
                this.searchActive = true;

                if (!isEmpty(this.formData)) {
                    this.criterias = this.formData;
                    this.showCriterias = true;
                }

                Promise.all([axios.post(advancedStatisticsAPI, this.formData)])
                    .then(response => {
                        console.log(response);
                        this.statistics = response[0].data;
                        this.showLoader = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(() => {
                        this.showLoader = false;
                        this.showForm = false;
                        this.searchActive = false;
                        this.searchFinished = true;
                    });
            }
        },
        watch: {
            statistics: function (newVal, oldVal) {
                this.statistics = newVal;
            },
            showLoader: function (newVal, oldVal) {
                this.showLoader = newVal;
            },
            criterias: {
                handler: function () {
                    for (var prop in this.criterias) {
                        if (!this.criterias[prop] || this.criterias[prop].length === 0) {
                            this.$delete(this.criterias, prop);
                        }
                    }
                },
                deep: true
            }
        },
        created() {
            let vm = this;

            if (!isEmpty(this.query) && !redirectedFromOtherBeneficiaries()) {
                this.formData = this.query;
                this.showForm = false;
            }

            function redirectedFromOtherBeneficiaries() {
                return (
                    window.location.href.slice(window.location.href.indexOf("?") + 1) ==
                    "onlyOtherBeneficiaries=true&page=1"
                );
            }

            this.showLoader = true;
            Promise.all([
                axios.get("/umbraco/surface/api/getadvancedstatisticsdropdownvalues"),
                ContentApi.getOtherBeneficiaries()
            ]).then(values => {
                var dropDowns = values[0].data;
                var otherBeneficiaries = values[1].data;
                this.schema = dropDowns;

                ProjectBeneficiariesService.handleBeneficiaries(
                    this.schema,
                    otherBeneficiaries,
                    this.formData
                );

                this.viewInitialized = true;
                this.showLoader = false;
            }).catch(error => {
                console.log(error);
            });

            window.onafterprint = function () {
                vm.results = vm.results.filter(rec => {
                    return !rec.printing;
                });
            };
        }
    };
</script>

<style lang="scss" scoped>
    @import "src/scss/variables";

    .form {
        width: 100%;
        padding: 30px 30px;
        border: 1px solid #b3afbd;
        border-radius: 3px;
        position: relative;
        margin: 20px 0;

        @media (max-width: 767px) {
            padding: 20px;
        }

        &__wrapper

    {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        @media (max-width: 767px) {
            flex-direction: column;
        }
    }

    &__column {
        flex: 0 0 50%;
        padding-right: 20px;
        box-sizing: border-box;
        &--right

    {
        padding-right: 0;
        padding-left: 20px;
    }

    }

    &__field {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex: 0 0 49%;
        width: 49%;
        margin-bottom: 15px;
        &.input

    {
        width: 250px;

        @media (max-width: 767px) {
            width: 100%;
        }
    }

    @media (max-width: 767px) {
        flex-direction: column;
        width: 100%;
    }

    }

    &__label {
        font-size: 15px;
        font-weight: 600;
        min-height: 40px;
        display: flex;
        align-items: center;
        text-align: left;

        @media (max-width: 767px) {
            margin-bottom: 10px;
            min-height: 0;
        }
    }

    &__submit-btn {
        width: 100%;
        height: 40px;
        background-color: $brand-light;
        border: 1px solid $brand-light;
        border-radius: 5px;
        font-family: $main-font;
        font-size: 15px;
        font-weight: 600;
        text-transform: uppercase;
        color: $color-light;
        transition: all 0.3s;
        outline: none;
        margin-top: 30px;
        &:focus, &:hover

    {
        background-color: #fff;
        color: $brand-primary;
    }

    .icon-search {
        position: relative;
        transform: rotate(45deg);
    }

    .number-input__controls > div {
        background-color: #ced3db !important;
    }

    }
    }
</style>

<style>
    table {
        border-collapse: collapse;
    }

    .statistics-table-row {
        border: black solid 1px;
    }

    .general-statistics {
        background-color: #a8ceff !important;
    }

    .summary-row {
        font-weight: bold;
    }

    .statistics-table .stat-td-center {
        text-align: center;
    }

    .statistics-table td {
        padding-left: 10px;
        padding-right: 10px;
        border-left: black solid 1px;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdvancedStatisticsForm.vue